import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  ResponsiveContainer,
  Cell,
  Text
} from 'recharts';
import { CustomBarLabel } from '../Utils';
import { useTheme } from '@material-ui/styles';
import { radiusVertical } from 'utils/charts';

interface TickProps {
  x: number;
  y: number;
  payload: any;
}

const CustomizedAxisTick = ({ x, y, payload }: TickProps) => {
  return (
    <Text
      x={x}
      y={y + 20}
      width={75}
      textAnchor="middle"
      verticalAnchor="start"
      style={{ color: 'red' }}
    >
      {payload.value}
    </Text>
  );
};

const dummyData = [
  { name: 'Risk requirement', value: 0 },
  { name: 'Risk tolerance', value: 0 },
  { name: 'Risk capacity', value: 0 },
  { name: 'Recommended risk profile', value: 0 }
];

interface RiskSummaryProps {
  data: Array<any>;
  isAnimationActive?: boolean;
  height?: number;
}
const RiskSummary = ({
  data,
  isAnimationActive = true,
  height = 300
}: RiskSummaryProps) => {
  const theme = useTheme() as any;
  const isDataProvided = data && data.length > 0;
  const dataToRender = isDataProvided ? data : dummyData;

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart
        data={dataToRender}
        margin={{ top: 20, right: 10, left: 0, bottom: 35 }}
        barCategoryGap={5}
      >
        <XAxis
          dataKey="name"
          axisLine={false}
          interval={0}
          tickLine={false}
          tick={(props: TickProps) => (
            <CustomizedAxisTick
              x={props.x}
              y={props.y}
              payload={props.payload}
            />
          )}
        />

        <Bar
          maxBarSize={100}
          dataKey="value"
          label={<CustomBarLabel />}
          isAnimationActive={isAnimationActive}
          radius={radiusVertical}
        >
          {dataToRender.map((_entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={theme.palette.baseColors.charts['risk-analysis'][index]}
            />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default RiskSummary;
